(ns ycweb.app.blitz.transfers.manualtransfers
  (:require
   [rum.core :as rum]
   [ycweb.components.forms :as forms]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.wrapper :as w]
   [ycweb.util.sound :as sound]
   [ycweb.components.common :as cmn]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.components.buttons :as buttons]
   [ycweb.app.blitz.unpacking.unpacking :as unpacking]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.flow :as flow]))

(def steps
  (forms/setup-steps
    [{:key :select-destination :title "Select Destination"}
     {:key :printer-scan :title "Scan Printer"}
     {:key :box-scan :title "Scan Box"}
     {:key :custom-box :title "Custom Box"}
     {:key :packbox-scan :title "Scan Packbox"}
     {:key :location-scan :title "Scan Location"}
     {:key :item-select :title "Scan Item"}
     {:key :item-scan :title "Scan Item"}
     {:key :packed-list :title "Packed Items"}
     {:key :ship :title "Ship"}
     {:key :shipping-printer-scan :title "Scan Printer"}
     {:key :finished :title "Finished"}]))

(defmethod flow/barcode-dispatch-screen :manualtransfers/finished [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/shipping-printer-scan {:scan scan}))

(rum/defc finished < rum/reactive [app-atom]
  (w/wrapper app-atom "Transfer Stock" {:steps steps :step :finished}
    [[:div
      {:class (u/bem :section [:medium])}
      [:h2.u-text-center
       {:class (u/bem :heading [:large])}
       [:b "Thank you!"]]
      [:i.u-block-center
       {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
      [:div.u-margin-top-24
       [:p.u-text-center
        {:class (u/bem :paragraph [:flush :large])}
        [:b "Put the stickers on the boxes"]]]]]

    [[:aside.page-body__footer
      [:p.paragraph.paragraph--flush.u-text-center
       "Scan a printer to reprint"]]]
    (grid/pos-call-to-action
      {:single-fn #(t/transition-next app-atom :main-menu)})))

(defmethod flow/render-screen :manualtransfers/finished [app-atom _]
  (finished app-atom))

(defmethod comms/receive :manualtransfers/ship [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :manualtransfers/finished))

(defmethod grid/action :manualtransfers/shipping-printer-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [ibt-uuid packbox to-location destination]} (get-in @app-atom [:manualtransfers])]
    (comms/send :manualtransfers/ship
      {:ibt-uuid ibt-uuid
       :to-location-id (:id to-location)
       :destination-id (:id destination)
       :shipping-printer scan
       :packbox packbox})))

(defmethod flow/barcode-dispatch-screen :manualtransfers/shipping-printer-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/shipping-printer-scan {:scan scan}))

(rum/defc shipping-printer-scan < rum/reactive [app-atom]
  (w/wrapper app-atom "Transfer Stock" {:steps steps :step :shipping-printer-scan}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Printer to ship"
       [:span.heading__subtext "for printing shipping stickers"]]
      grid/barcode-icon]]
    []

    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-text "Scan Printer"
       :right-plain true})))

(defmethod flow/render-screen :manualtransfers/shipping-printer-scan [app-atom _]
  (shipping-printer-scan app-atom))

(rum/defc packed-list < rum/reactive [app-atom]
  (let [{:keys [packed-items to-location]} (cmn/curact app-atom :manualtransfers)]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :packed-list}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "List of Packed Items"
         [:span {:class "heading__subtext"}
          [:b (:barcode to-location)]]]]
       [:div.slats
        (map unpacking/item-slat packed-items)]]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Ship IBT"
         :right-fn #(t/transition-next app-atom :manualtransfers/shipping-printer-scan)}))))

(defmethod flow/render-screen :manualtransfers/packed-list [app-atom _]
  (packed-list app-atom))

(defmethod comms/receive :manualtransfers/packed-list [app-atom {:keys [packed-items ibt-uuid]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :manualtransfers assoc
    :packed-items packed-items
    :ibt-uuid ibt-uuid)
  (t/transition-next app-atom :manualtransfers/packed-list))

(defmethod grid/action :manualtransfers/packed-list [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [to-location (get-in @app-atom [:manualtransfers :to-location])]
    (toaster/open-subtle-progress app-atom)
    (comms/send :manualtransfers/packed-list
      {:to-location-id (:id to-location)})))

(defmethod comms/receive :manualtransfers/item-scan [app-atom {:keys [items]}]
  (let [{:keys [scan-qty scanned from-location]} (get-in @app-atom [:manualtransfers])]
    (toaster/close-subtle-progress app-atom)
    (sound/play :scan)
    (cond
      (and items (empty? items))
      (t/transition-next app-atom :manualtransfers/location-scan)

      items
      (do
        (swap! app-atom assoc-in [:manualtransfers :items] items)
        (grid/dispatch-action app-atom :manualtransfers/location-scan {:scan (:barcode from-location)}))

      :else
      (swap! app-atom assoc-in [:manualtransfers :scanned] (+ scan-qty scanned)))))

(defmethod grid/action :manualtransfers/item-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [from-location to-location scan-qty]} (get-in @app-atom [:manualtransfers])]
    (toaster/open-subtle-progress app-atom)
    (comms/send :manualtransfers/item-scan
      {:scan scan
       :qty scan-qty
       :to-location-id (:id to-location)
       :from-location-id (:id from-location)})))

(defmethod flow/barcode-dispatch-screen :manualtransfers/item-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/item-scan {:scan scan}))

(rum/defc item-scan < rum/reactive [app-atom]
  (let [{:keys [from-location to-location selected-item scanned]} (cmn/curact app-atom :manualtransfers)
        {:keys [features brand product qty images barcode]} selected-item]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :item-scan}
      [[:div.section
        [:h2.u-text-center.heading
         {:class (u/bem :heading [:standard :flush])}
         "Scan items and put into:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b (:name to-location)]
         [:span.heading__subtext
          "Taking from"]
         [:span.heading__subtext
          "Shelf: " [:b (:name from-location)]]]]
       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:span.product-card__scan-count (str (or scanned 0) " / " (or qty 0))]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :manualtransfers/location-scan {:scan (:barcode from-location)})
         :right-text "Scan Item"
         :right-plain true}))))

(defmethod flow/render-screen :manualtransfers/item-scan [app-atom _]
  (item-scan app-atom))

(defmethod comms/receive :manualtransfers/item-select [app-atom {:keys [selected-item]}]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (swap! app-atom update :manualtransfers assoc
    :selected-item selected-item
    :scanned 0
    :scan-qty 1)

  (t/transition-next app-atom :manualtransfers/item-scan))

(defmethod grid/action :manualtransfers/item-select [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [from-location (get-in @app-atom [:manualtransfers :from-location])]
    (comms/send :manualtransfers/item-select {:scan scan :from-location-id (:id from-location)})))

(defmethod flow/barcode-dispatch-screen :manualtransfers/item-select [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/item-select {:scan scan}))

(defmethod comms/receive :manualtransfers/bulk-pack [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :manualtransfers/location-scan))

(defmethod grid/action :manualtransfers/bulk-pack [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [from-location to-location]} (get-in @app-atom [:manualtransfers])]
    (toaster/open-subtle-progress app-atom)
    (comms/send :manualtransfers/bulk-pack
      {:to-location-id (:id to-location)
       :from-location-id (:id from-location)})))

(defmethod grid/action :aftersalesreceiving/bulk-pack-menu [app-atom _ _]
  (grid/confirm-modal app-atom
    {:title "Cancel Session"
     :text [:p {:class (u/bem :paragraph [:flush])}
            "Are you sure you want to move all items from this shelf"]
     :confirm-key :manualtransfers/bulk-pack
     :confirm-text "Yes" :icon-left :delete :icon-class :3-2 :negative true}))

(defn change-location-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Change Location"
       :grid-action :manualtransfers/change-location}

      {:label "Bulk Move"
       :action :manualtransfers/bulk-pack-menu
       :style
       {:full true :large true :negative true
        :icon-left :warning :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :manualtransfers/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc item-select < rum/reactive [app-atom]
  (let [{:keys [from-location from-location-items]} (cmn/curact app-atom :manualtransfers)]
    (w/wrapper app-atom "Transfer Stock" {:modal-fn change-location-modal :steps steps :step :item-select}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Item to start Packing"
         [:span {:class "heading__subtext"}
          "Location: " [:b (:barcode from-location)]]]]
       [:div.slats
        (map unpacking/item-slat from-location-items)]]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Pack List"
         :right-fn #(grid/dispatch-action app-atom :manualtransfers/packed-list {})}))))

(defmethod flow/render-screen :manualtransfers/item-select [app-atom _]
  (item-select app-atom))

(defmethod comms/receive :manualtransfers/location-scan [app-atom {:keys [location items]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :manualtransfers assoc
    :from-location-items items
    :from-location location)
  (t/transition-next app-atom :manualtransfers/item-select))

(defmethod grid/action :manualtransfers/location-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :manualtransfers/location-scan {:scan scan}))

(defmethod flow/barcode-dispatch-screen :manualtransfers/location-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/location-scan {:scan scan}))

(rum/defc location-scan < rum/reactive [app-atom]
  (w/wrapper app-atom "Transfer Stock" {:modal-fn change-location-modal :steps steps :step :location-scan}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Location"
       [:span.heading__subtext "to take items from "]]
      grid/barcode-icon]]
    []

    (grid/pos-call-to-action
      {:left-plain true
       :right-text "Pack List"
       :right-fn #(grid/dispatch-action app-atom :manualtransfers/packed-list {})})))

(defmethod flow/render-screen :manualtransfers/location-scan [app-atom _]
  (location-scan app-atom))

(defmethod grid/action :manualtransfers/change-location [app-atom _ _]
  (t/transition-next app-atom :manualtransfers/location-scan))

(defmethod grid/action :manualtransfers/packbox-scan [app-atom {:keys [scan]} _]
  (let [to-location (get-in @app-atom [:manualtransfers :to-location])]
    (cond
      (not= scan (:barcode to-location))
      (toaster/open-toast app-atom :error "Wrong Packbox." {})

      :else
      (t/transition-next app-atom :manualtransfers/location-scan))))

(defmethod flow/barcode-dispatch-screen :manualtransfers/packbox-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/packbox-scan {:scan scan}))

(rum/defc packbox-scan < rum/reactive [app-atom]
  (let [to-location (cmn/curact app-atom [:manualtransfers :to-location])]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :packbox-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Packbox"
         [:span.heading__subtext "scan " (:barcode to-location) " to confirm PB"]]
        grid/barcode-icon]]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Packbox"
         :right-plain true}))))

(defmethod flow/render-screen :manualtransfers/packbox-scan [app-atom _]
  (packbox-scan app-atom))

(defmethod comms/receive :manualtransfers/custom-reprint [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :manualtransfers/custom-ship))

(defmethod grid/action :manualtransfers/custom-reprint [app-atom {:keys [scan]} _]
  (swap! app-atom assoc-in [:manualtransfers :printer] scan)
  (let [{:keys [waybill-id]} (get-in @app-atom [:manualtransfers])]
    (comms/send :manualtransfers/custom-reprint
      {:waybill-id waybill-id
       :printer scan})))

(defmethod flow/barcode-dispatch-screen :manualtransfers/custom-ship  [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/custom-reprint {:scan scan}))

(rum/defc custom-ship < rum/reactive [app-atom]
  (let [{:keys [to-location]} (cmn/curact app-atom :manualtransfers)]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :finished}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Reprint"]
        grid/barcode-icon]]

      [[:aside.page-body__footer
        [:p.paragraph.paragraph--flush.u-text-center
         "Scan a printer to reprint"]]]

      (grid/pos-call-to-action
        {:single-fn #(grid/dispatch-action app-atom :manualtransfers/custom-box {:ibt-uuid (u/uuid)})}))))

(defmethod flow/render-screen :manualtransfers/custom-ship [app-atom _]
  (custom-ship app-atom))

(defmethod comms/receive :manualtransfers/custom-ship [app-atom {:keys [waybill-id]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:manualtransfers :waybill-id] waybill-id)
  (t/transition-next app-atom :manualtransfers/custom-ship))

(defmethod grid/action :manualtransfers/custom-ship [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [printer custom-box destination ibt-uuid]} (:manualtransfers @app-atom)]
    (toaster/open-subtle-progress app-atom)
    (comms/send :manualtransfers/custom-ship
      {:ibt-uuid ibt-uuid
       :printer printer
       :destination-id (:id destination)
       :massmg (* (:massmg custom-box) 1000)
       :lengthmm (:lengthmm custom-box)
       :widthmm (:widthmm custom-box)
       :heightmm (:heightmm custom-box)
       :description (:description custom-box)})))

(defmethod grid/action :manualtransfers/custom-box [app-atom {:keys [ibt-uuid]} _]
  (swap! app-atom update :manualtransfers assoc
    :custom-box nil
    :ibt-uuid ibt-uuid)
  (t/transition-next app-atom :manualtransfers/custom-box))

(rum/defc custom-box < rum/reactive cmn/cursors [app-atom]
  (let [box (rum/cursor-in app-atom [:manualtransfers :custom-box])]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :custom-box}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Custom Box"]

        [:div.form-field
         (forms/input "Weight (kg):" "5" (rum/cursor box :massmg)
           {:type :number :required? true})]
        [:div.form-field
         (forms/input "Length (mm):" "100" (rum/cursor box :lengthmm)
           {:type :number :required? true})]
        [:div.form-field
         (forms/input "Width (mm):" "100" (rum/cursor box :widthmm)
           {:type :number :required? true})]
        [:div.form-field
         (forms/input "Height (mm):" "100" (rum/cursor box :heightmm)
           {:type :number :required? true})]
        [:div.form-field
         (forms/input "Description:" "" (rum/cursor box :description))]]]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Ship"
         :right-fn
         (when
           (and
             (cmn/curact box :massmg)
             (cmn/curact box :lengthmm)
             (cmn/curact box :widthmm)
             (cmn/curact box :heightmm)
             (cmn/curact box :description))
           #(grid/dispatch-action app-atom :manualtransfers/custom-ship
              {:ibt-uuid (cmn/curact app-atom [:manualtransfers :ibt-uuid])}))}))))

(defmethod flow/render-screen :manualtransfers/custom-box [app-atom _]
  (custom-box app-atom))

(defmethod comms/receive :manualtransfers/box-scan [app-atom {:keys [location packbox]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :manualtransfers assoc
    :to-location location
    :packbox packbox)
  (t/transition-next app-atom :manualtransfers/packbox-scan))

(defmethod grid/action :manualtransfers/box-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [printer destination]} (get-in @app-atom [:manualtransfers])]
    (comms/send :manualtransfers/box-scan
      {:destination destination
       :printer printer
       :scan scan})))

(defmethod flow/barcode-dispatch-screen :manualtransfers/box-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/box-scan {:scan scan}))

(rum/defc box-scan < rum/reactive [app-atom]
  (let [printer (cmn/curact app-atom [:manualtransfers :printer])]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :box-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Box"
         [:span.heading__subtext (str "to print a PB to " printer)]]
        grid/barcode-icon]]

      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:large])}
         [:a.text-link
          {:on-click #(grid/dispatch-action app-atom :manualtransfers/custom-box {:ibt-uuid (u/uuid)})}
          "Add Custom Box"]]]]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Box"
         :right-plain true}))))

(defmethod flow/render-screen :manualtransfers/box-scan [app-atom _]
  (box-scan app-atom))

(defmethod grid/action :manualtransfers/printer-scan [app-atom {:keys [scan]} _]
  (swap! app-atom assoc-in [:manualtransfers :printer] scan)
  (if (:blitz? @app-atom)
    (t/transition-next app-atom :manualtransfers/box-scan)
    (grid/dispatch-action app-atom :manualtransfers/custom-box {:ibt-uuid (u/uuid)})))

(defmethod flow/barcode-dispatch-screen :manualtransfers/printer-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :manualtransfers/printer-scan {:scan scan}))

(rum/defc printer-scan < rum/reactive [app-atom]
  (let [destination (cmn/curact app-atom [:manualtransfers :destination])]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :printer-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Printer"
         [:span.heading__subtext "for printing " (:name destination) " PB stickers"]]
        grid/barcode-icon]]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Printer"
         :right-plain true}))))

(defmethod flow/render-screen :manualtransfers/printer-scan [app-atom _]
  (printer-scan app-atom))

(defmethod grid/action :manualtransfers/select-destination [app-atom {:keys [destination]} _]
  (swap! app-atom assoc-in [:manualtransfers :destination] destination)
  (t/transition-next app-atom :manualtransfers/printer-scan))

(rum/defc warehouse-slat < rum/reactive
  [warehouse {:keys [on-click]}]
  [:article.slat-wrapper
   [:a.slat.store-slat
    {:href "#" :on-click (when on-click on-click)}
    [:div.store-slat__branding
     [:div.store-slat__icon-wrapper
      [:i.store-slat__icon
       {:class (u/bem :icon [:block :location :2-2])}]]]
    [:div.store-slat__info
     [:h3.store-slat__title (:name warehouse)]]]])

(rum/defc select-destination < rum/reactive [app-atom]
  (let [warehouses (cmn/curact app-atom [:manualtransfers :warehouses])]
    (w/wrapper app-atom "Transfer Stock" {:steps steps :step :select-destination}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Choose a Destination"]]
       [:div.slats
        (->>
          warehouses
          (map
            (fn [warehouse]
              (warehouse-slat warehouse
                {:on-click
                 #(grid/dispatch-action app-atom :manualtransfers/select-destination {:destination warehouse})}))))]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-next app-atom :main-menu)
         :right-plain true}))))

(defmethod flow/render-screen :manualtransfers/select-destination [app-atom _]
  (select-destination app-atom))

(defmethod comms/receive :manualtransfers/warehouse-list [app-atom {:keys [warehouses]}]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:manualtransfers :warehouses] warehouses)
  (t/transition-next app-atom :manualtransfers/select-destination))

(defmethod grid/action :manualtransfers/warehouse-list [app-atom _ _]
  (toaster/open-toast app-atom :processing "Loading warehouses" {})
  (comms/send :manualtransfers/warehouse-list {}))